<template>
    <p class="mt-120">&copy; 2025 Mihajlo Petrović. All rights reserved.</p>
</template>

<script>
export default {
    name: 'FooterBar',
}
</script>

<style scoped>
p {
    color: #462e9e;
}
</style>